const signalRConfig = {
  // Azure Functions API base URL for SignalR negotiate endpoint
  // In production (deployed to Azure Static Web Apps), this defaults to '/api'
  // In development, set VITE_SIGNALR_API_URL=http://localhost:7071/api in .env.local
  apiUrl: import.meta.env.VITE_SIGNALR_API_URL || '/api'
};

export const SIGNALR_LISTENERS = {
  ON_EXTRACTION_STATUS_UPDATED: 'ExtractionStatusUpdate',
  ON_AUTOMATION_EXTRACTION_STATUS_UPDATED: 'AutomationExtractionUpdate',
  ON_TRANSFORMATION_STATUS_UPDATED: 'TransformationStatusUpdate',
  ON_AUTOMATION_TRANSFORMATION_STATUS_UPDATED: 'AutomationTransformationUpdate',
  // TransformationUpdate — { environment, period_id, ... }
  // Fires whenever a transformation's data payload changes (apply/save/edit),
  // not just status transitions. Wire to the same handler as the status
  // events so transformation grids refetch on data-only updates too.
  ON_TRANSFORMATION_UPDATED: 'TransformationUpdate',
  ON_AUTOMATION_REPORT_STATUS_UPDATED: 'AutomationReportTaskUpdate',
  // WorkflowPeriodUpdate — { environment, workflow_id, period_id? }
  // Any change in a workflow's periods list: period created, status changes,
  // deletion, regenerate AIFM report flow.
  ON_WORKFLOW_PERIOD_UPDATED: 'WorkflowPeriodUpdate',
  // FileProcessingUpdate — { environment, period_id, file_id, status }
  // File upload state changes (uploading → processing → completed/failed),
  // password-protected detection, sheet/preview extraction completes.
  ON_FILE_PROCESSING_UPDATED: 'FileProcessingUpdate',
  // FundExtractionUpdate — { environment, period_id, fund_id? }
  // A fund's files_as_per_input or bulk_uploaded_files extraction finishes,
  // or per-fund extraction status changes.
  ON_FUND_EXTRACTION_UPDATED: 'FundExtractionUpdate',
  // OutputTableStatusUpdate — { environment, period_id, output_table_id?, status }
  // Output-table generation transitions in/out of "In progress" (outer
  // status AND inner task.status).
  ON_OUTPUT_TABLE_STATUS_UPDATED: 'OutputTableStatusUpdate',
  ON_APPROVAL_STATUS_UPDATED: 'ApprovalStatusUpdate',
  // StatisticsJobUpdate — { environment, period_id, workflow_id, job_id, type, status }
  // A statistics job ended (completed/failed); its result is ready at GET statistics-jobs/{job_id}.
  ON_STATISTICS_JOB_UPDATED: 'StatisticsJobUpdate',
  // AutoMapUpdate — { environment, period_id, workflow_id, task_id, sheet_id, category, status, error_message }
  // An Auto-Map task ended: completed, cancelled or failed.
  ON_AUTO_MAP_UPDATED: 'AutoMapUpdate',
  // FundMappingsUpdate — { environment, period_id, workflow_id, action }
  // A period's automation fund mappings were written, saved, deleted or copied.
  ON_FUND_MAPPINGS_UPDATED: 'FundMappingsUpdate',
  // PeriodFundsUpdate — { environment, period_id, workflow_id, file_id }
  // Funds detected from an uploaded file were saved to the period.
  ON_PERIOD_FUNDS_UPDATED: 'PeriodFundsUpdate'
};

export default signalRConfig;
